import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Page} from '../../../core/pagination/page';
import {Client} from '../../client';
import {PageRequest} from '../../../core/pagination/page-request';
import {SortOrder} from '../../../core/sort/sort-order';
import {ClientPageRequest} from '../../client-page-request';
import {ClientenFilter} from '../filter/clienten-filter';

@Component({
    selector: 'zah-clienten-overzicht-therapeut',
    templateUrl: './clienten-overzicht-therapeut.component.html',
    styleUrls: ['./clienten-overzicht-therapeut.component.scss'],
    standalone: false
})
export class ClientenOverzichtTherapeutComponent implements OnInit {

  @Input()
  initialPageRequest: ClientPageRequest;
  @Input()
  clientenPage: Page<Client>;
  @Output()
  clientClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  pageChange: EventEmitter<ClientPageRequest> = new EventEmitter<ClientPageRequest>();

  private currentPageRequest: ClientPageRequest;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  onClientClick(client: Client): void {
    this.clientClicked.emit(client);
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = this.currentPageRequest.withSortOrder(sortOrder);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = this.currentPageRequest.withPageSize(pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<Client>): void {
    this.currentPageRequest = this.currentPageRequest.forPageRequest(pageRequest);
    this.pageChange.emit(this.currentPageRequest);
  }

  onSearch(clientenFilter: ClientenFilter): void {
    if (clientenFilter.hasClientnummer() || clientenFilter.hasClientAchternaam()) {
      this.currentPageRequest = ClientPageRequest.clientFilterRequest(clientenFilter, this.currentPageRequest);
      this.pageChange.emit(this.currentPageRequest);
    }
  }
}
